'use client'
import Field from './FormBlock.Field.client'
import styles from './FormBlock.module.scss'
import Select from '@/src/components/common/Select'

export default function ContactUsFormFields() {
  return (
    <>
      <Field
        required
        label={'First name'}
        input={
          <input
            name={'First_Name'}
            type={'text'}
            placeholder={'First name'}
            required
            autoComplete={'off'}
          />
        }
        className={styles.half}
      />
      <Field
        label={'Last name'}
        input={<input name={'Last_Name'} type={'text'} placeholder={'Last name'} />}
        className={styles.half}
      />
      <Field
        required
        label={'Email address'}
        input={<input name={'Email'} type={'email'} placeholder={'Email address'} />}
        className={styles.full}
      />
      <Field
        label={'Mobile phone'}
        input={
          <input
            name={'Mobile_Phone'}
            type={'phone'}
            placeholder={'Mobile phone'}
            pattern="(0)(4|5)[0-9]{8}"
            minLength={10}
            maxLength={10}
          />
        }
        className={styles.half}
      />
      <Field
        label={'Landline Phone'}
        input={
          <input
            name={'Landline_Phone'}
            type={'phone'}
            placeholder={'Landline Phone'}
            pattern="(0)(2|3|7|8)[0-9]{8}"
            minLength={10}
            maxLength={10}
          />
        }
        className={styles.half}
      />
      <Field
        required
        label={'Reason for your message'}
        input={
          <Select
            name={'Reason'}
            options={[
              'Looking for more information',
              'General feedback',
              'Complaint',
              'Compliment',
              'Other',
            ]}
          />
        }
        className={styles.half}
      />
      <Field
        required
        label={'Who is it for?'}
        input={
          <Select
            name={'Assistance_for'}
            options={['Myself', 'My Mother', 'My Father', 'My Parents', 'My Partner', 'Other']}
          />
        }
        className={styles.half}
      />
      <Field
        label={'Comments'}
        input={<textarea name={'Comments'} placeholder={'Enter details here'} />}
        className={styles.full}
      />
      <input type="hidden" name="formSourceName" value="StandardForm" />
      <input type="hidden" name="sp_exp" value="yes" />
    </>
  )
}
